import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["id", "aria-controls", "aria-selected", "disabled", "onClick"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextTabs',
    props: {
        className: { default: undefined },
        innerClassName: { default: undefined },
        color: { default: 'default' },
        hasButton: { type: Boolean, default: false },
        buttonIconName: { default: undefined },
        tabs: {},
        ariaLabel: { default: '탭 목록' }
    },
    emits: ["tabClick", "update:activeTab"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const input = tv({
            slots: {
                tabsCover: clsx('overflow-hidden', '', ''),
                tabsInner: clsx('flex overflow-y-auto', 'gap-28', 'desktop:gap-32'),
                tabItem: clsx('flex items-center whitespace-nowrap text-gray-600 disabled:text-gray-300', 'text-m-title-2', 'desktop:text-body-3'),
                tabCountStyle: clsx('', 'ml-4', 'desktop:ml-6'),
            },
            variants: {
                color: {
                    default: {
                        tabItem: 'hover:text-blue-700',
                    },
                    teal: {
                        tabItem: 'hover:text-teal-700',
                    },
                    violet: {
                        tabItem: 'hover:text-violet-500',
                    },
                    mutedBlue: {
                        tabItem: 'hover:text-muted-blue-500',
                    },
                    dark: {
                        tabItem: 'hover:text-blue-600 disabled:text-gray-800',
                    },
                },
                isActive: {
                    true: '',
                    false: '',
                },
            },
            compoundVariants: [
                {
                    color: 'default',
                    isActive: true,
                    class: {
                        tabItem: 'text-blue-700',
                    },
                },
                {
                    color: 'teal',
                    isActive: true,
                    class: {
                        tabItem: 'text-teal-700',
                    },
                },
                {
                    color: 'violet',
                    isActive: true,
                    class: {
                        tabItem: 'text-violet-700',
                    },
                },
                {
                    color: 'mutedBlue',
                    isActive: true,
                    class: {
                        tabItem: 'text-muted-blue-700',
                    },
                },
                {
                    color: 'dark',
                    isActive: true,
                    class: {
                        tabItem: 'text-blue-600',
                    },
                },
            ],
            defaultVariants: {
                color: 'default',
                isActive: false,
            },
        });
        const { tabsCover, tabsInner, tabItem, tabCountStyle } = input();
        const handleTabClick = (tab) => {
            if (!tab.disabled) {
                emit('tabClick', tab);
                emit('update:activeTab', tab.id);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "aria-label": props.ariaLabel,
                class: _normalizeClass(_unref(clsx)(_unref(tabsCover)(), props.className)),
                role: "tablist"
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(_unref(clsx)(_unref(tabsInner)({ class: __props.innerClassName })))
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            id: tab.id,
                            key: tab.id,
                            "aria-controls": `${tab.id}-panel`,
                            "aria-selected": tab.isActive,
                            class: _normalizeClass(_unref(clsx)(_unref(tabItem)({
                                color: props.color,
                                isActive: tab.isActive,
                            }))),
                            disabled: tab.disabled,
                            role: "tab",
                            type: "button",
                            onClick: ($event) => (handleTabClick(tab))
                        }, [
                            _createTextVNode(_toDisplayString(tab.text) + " ", 1),
                            (tab.tabCount)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    "aria-label": "탭 항목 수",
                                    class: _normalizeClass(_unref(clsx)(_unref(tabCountStyle)()))
                                }, _toDisplayString(tab.tabCount), 3))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_2));
                    }), 128))
                ], 2)
            ], 10, _hoisted_1));
        };
    }
});
